import i18n from "i18next";
import { initReactI18next } from "react-i18next";


import en from "./locales/en.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import es from "./locales/es.json";


const resources = {

  en:{
    translation: en
  },

  fr:{
    translation: fr
  },

  de:{
    translation: de
  },

  es:{
    translation: es
  }

};



i18n
.use(initReactI18next)
.init({

  resources,

  lng: localStorage.getItem("lang") || "en",

  fallbackLng:"en",

  interpolation:{
    escapeValue:false
  }

});


export default i18n;